import React from 'react'
import {Link} from 'react-router-dom'

import polymedia_png from '../assets/polymedia-peter-van-der-meer.png';
import img_creator from '../assets/bountyhub-creator.png';
import img_company from '../assets/bountyhub-company.png';
import img_bounties from '../assets/bountyhub-bounties.png';


export default class extends React.Component {

  render() {
    return (
      <div>

        <div className="full header">
        <div style={{position:"absolute", top:"-25px", right:"12px"}}>
          {!this.props.session_token && <div><Link to="/" onClick={(e) => this.props.openModal(e)} className="cta">Login</Link></div>}
          {this.props.session_token && <div><Link to="/" className="cta">Dashboard</Link></div>}
        </div>
          <div className="wrap">
            <h1>{this.props.config.app_id}</h1>
            <h2>Streamers, easily find exciting new sponsors!</h2>
            <h3>Complete &quot;Bounties&quot; to earn some extra cash. This independent Europe-focused platform makes it easy to directly and instantly find Sponsor Opportunities.</h3>
          </div>
        </div>

        <div className="full big">
          <div className="wrap content-text" style={{textAlign:"center"}}>
            <p style={{textAlign:"center"}}>Ready to check it out? Press the button below to create a free and no-strings-attached account!</p>
            {!this.props.session_token && <div><Link to="/" onClick={(e) => this.props.openModal(e, "register")} className="cta">Start now!</Link></div>}
            {this.props.session_token && <div><Link to="/" className="cta">Dashboard</Link></div>}
          </div>
        </div>

        <div className="full big purple">
          <div className="wrap content-block">
              <div className="col-2">
                <h1>Are you a Creator?</h1><h2>Want to earn something extra for your efforts? Easily and directly find companies that offer opportunities to get paid in different ways.</h2>
                {!this.props.session_token && <div><Link to="/" onClick={(e) => this.props.openModal(e, "register")} className="cta">Start now!</Link></div>}
              </div>
              <div className="col-2"><img src={img_creator} alt="BountyHub.net | Europe-focused platform for Creator Bounties" className="screenshot" style={{margin:"0 auto", maxHeight:"340px"}} /></div>
          </div>
        </div>

        <div className="full big orange">
          <div className="wrap content-block">
              <div className="col-2">
                <h1>Are you a company?</h1><h2>Easily find influencers that want to promote your brand or product on their platforms.</h2>
                {!this.props.session_token && <div><Link to="/" onClick={(e) => this.props.openModal(e, "register")} className="cta">Start now!</Link></div>}
              </div>
              <div className="col-2"><img src={img_company} alt="BountyHub.net | Europe-focused platform for Creator Bounties" className="screenshot" style={{margin:"0 auto", maxHeight:"340px"}} /></div>
          </div>
        </div>

        <div className="full big purple">
          <div className="wrap content-block">
              <div className="col-2">
                <h1>How does it work?</h1><h2>Companies post information about the Promotion Opportunities for everyone to see, called a &quot;Bounty&quot;. The company has paid to post this Bounty, there is no cost for the Creator. You can let your interest be known and then be able to execute the Bounty.</h2>
              </div>
              <div className="col-2"><img src={img_bounties} alt="BountyHub.net | Europe-focused platform for Creator Bounties" className="screenshot" style={{margin:"0 auto", maxHeight:"340px"}} /></div>
          </div>
        </div>

        <div className="full big orange">
          <div className="wrap content-block">
              <div className="col-2">
                <h1>Who is Polymedia?</h1><h2>Polymedia consists of a single experienced developer that has developed and maintained multiple popular Extensions for Twitch, the most known are Twitter Feed+ and Instagram Feed+, two Twitch Extensions that daily hundreds of new streamers install on their profiles.<br/><br/>After over five years of development on multiple Twitch Extensions I noticed that there is no simple service to easily get Sponsor Opportunities for your stream, especially in Europe. This platform is accessible for everyone, but most companies will be contacted that are at least based in Europe.</h2>
                <div className="socials"><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer" style={{marginRight:"42px"}}>LinkedIn</a><a href="https://x.com/PolymediaNL" target="_blank" rel="noopener noreferrer" style={{marginRight:"42px"}}>Twitter</a><a href="https://www.threads.net/@bountyhub_" target="_blank" rel="noopener noreferrer">Threads</a></div>
              </div>
              <div className="col-2"><img src={polymedia_png} alt="BountyHub.net | Europe-focused platform for Creator Bounties" className="screenshot" style={{margin:"0"}} /></div>
          </div>
        </div>

{/*<div className="full big greyish">
          <div className="wrap content-block">
              <div className="col-2">
                <h1>Twitch tries 'Bounty Board' approach to setting streamers up for sponsored streams</h1><h2>This week Twitch rolled out a beta of its Bounty Board program, which aims to cut out third-party marketing agencies by directly connecting Twitch streamers with companies who will pay them to stream.</h2>
              </div>
              <div className="col-2"><img src={example_screenshot2} alt="BountyHub.net | Europe-focused platform for Creator Bounties" className="screenshot" style={{margin:"0"}} /></div>
          </div>
        </div>*/}

        <div id="faq" className="full big purple">
          <div className="wrap content-block">
              <div className="">
                <h1>Frequently Asked Questions</h1>

                <h2>What are "Bounties"?</h2>
                <p>Bounties are the Sponsors listed in the platform. Brands will provide information about their opportunity, and Creators will be able to let their interest be known for working with this Bounty. The list of Bounties is called the Bounty Board.</p>

                <h2>Is this service limited to Twitch?</h2>
                <p>No, the idea started from developing for and watching Twitch, but the &quot;Bounties&quot; (Sponsor Opportunities) will also be available for Kick, YouTube and other Live and non-Live platforms, depending on the preference of the company that offers the Bounty.</p>

                <h2>What is BountyHub.NET?</h2>
                <p>BountyHub.NET is an independent Europe-focused platform that makes it easy to directly and instantly find Sponsor Opportunities. Companies can simply post an advertisement, called a &quot;Bounty&quot;, and Influencers, Streamers, and other people we call &quot;Creators&quot; can simply respond to these Bounties within the same platform to get more information about what they are required to do to complete the Bounty.
                <br/><br/>
                As a Creator you can respond to any Bounty that fits your work – with no cost at all. There&apos;s always something new to try, and new Bounties are added all the time!</p>

                <h2>How much does BountyHub.NET cost?</h2>
                <p>For the Companies posting their &quot;Bounties&quot; there is a price, besides the time required to set up the Bounty and their Profile, which is easy to do on this platform. It is up to the company to set up contracts or additional requirements for the Creator to sign or follow before they accept the Bounty as completed. There is no cost in signing up for the service for either party, so just make an account and take a look!<br/><br/>For the Creators, there is no cost.</p>

                <h2>For Companies, are BountyHub.NET advertisements refundable?</h2>
                <p>None of the purchased BountyHub.NET advertisements are refundable.</p>
              </div>
          </div>
        </div>

        <div className="full big">
          <div className="wrap content-text" style={{textAlign:"center"}}>
            <p style={{textAlign:"center"}}>Ready to check it out? Press the button below to create a free and no-strings-attached account!</p>
            {!this.props.session_token && <div><Link to="/" onClick={(e) => this.props.openModal(e, "register")} className="cta">Start now!</Link></div>}
            {this.props.session_token && <div><Link to="/" className="cta">Dashboard</Link></div>}
          </div>
        </div>

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Start.js